import { defineStore } from 'pinia';
import { userInfo_get, type UserInfoResponseI } from '~/api/cards/trade.js';
import { useIndexStore } from './index';

export const useCardsStore = defineStore('cards', {
    state: () => ({
        userInfo: {} as UserInfoResponseI,
        cards: [],
        showPreValidation: false,
        showBaseValidation: undefined as string | undefined,
        }),
    actions: {
        setUserInfo(info: UserInfoResponseI) {
            this.userInfo = info;
        },
        async getUserInfo(getNew: boolean = false) {
            if(getNew){
                const res = await userInfo_get();
                this.setUserInfo(res.data);
                return res.data;
            }
            if(this.userInfo && Object.keys(this.userInfo).length > 0){
                return this.userInfo;
            }
            const res = await userInfo_get();
            this.setUserInfo(res.data);
            return res.data;
        },
        setShowPreValidation(show: boolean) {
            this.showPreValidation = show;
        },
        setShowBaseValidation(showType: string | undefined) {
            this.showBaseValidation = showType;
        },
        openPreValidation() {
            return this.getUserInfo(true).then(userInfo => {
                const indexStore = useIndexStore();
                
                // 如果userInfo.kycAuditResult=forbidden 国家错误
                if(userInfo?.kycAuditResult !== 'pass' || userInfo?.accountTypeCheckResult !== 'pass') {
                    // 校验顺序 1 - 受限制国家
                    if(userInfo?.kycAuditResult === 'forbidden'){
                        indexStore.SHOW_KYC_COUNTRY_LIMIT_DIALOG_WIDTH_DATA({
                            countryCodeList: userInfo?.forbiddenCountries || [],
                        });
                    // 2 - KYC1    
                    }else if(userInfo?.kycAuditResult=== 'needKyc1') {
                        this.setShowBaseValidation('KYC_1');
                    }else if(userInfo?.accountTypeCheckResult === 'forbidden') {
                        this.setShowBaseValidation('ACCOUNT_TYPE_RESTRICTED');
                    }else if(!userInfo?.kyc2Verify || !userInfo?.emailVerify) {
                        this.setShowPreValidation(true);
                    }
                    
                    return true;
                }
                
                return false;
            });
        }
    }
});